import '@babel/polyfill';
import 'url-polyfill';
import 'custom-event-polyfill';

import '../styles/index.scss';
import * as lazyload from './modules/lazyload';
import * as Plyr from 'plyr';

window.addEventListener('load', init);

function init() {
  lazyload
    .init('.lazyload', {
      rootMargin: '100px',
      threshold: 0
    })
    .observe();

  // https://github.com/sampotts/plyr/#options
  new Plyr(document.getElementById('video'), {
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
    loadSprite: true,
    captions: {
      active: true,
      update: true,
      language: 'de'
    },
    ratio: '16:9'
  });
}
